document.addEventListener('DOMContentLoaded', function() {
  const showcaseContainers = document.querySelectorAll('.mt-product-showcase__container');
  
  showcaseContainers.forEach(function(container) {
    // 查找右侧区域内的元素
    const rightSection = container.querySelector('.mt-product-showcase__right');
    if (!rightSection) {
      console.log('Right section not found');
      return;
    }
    
    const productsContainer = rightSection.querySelector('.mt-product-showcase__products');
    const leftArrow = rightSection.querySelector('.mt-product-showcase__arrow--left');
    const rightArrow = rightSection.querySelector('.mt-product-showcase__arrow--right');
    const scrollbar = rightSection.querySelector('.mt-product-showcase__scrollbar');
    const scrollbarThumb = rightSection.querySelector('.mt-product-showcase__scrollbar-thumb');
    const scrollbarTrack = rightSection.querySelector('.mt-product-showcase__scrollbar-track');
    
    if (!productsContainer) {
      console.log('Products container not found');
      return;
    }
    
    console.log('Products container found:', productsContainer);
    console.log('Products container scrollWidth:', productsContainer.scrollWidth);
    console.log('Products container offsetWidth:', productsContainer.offsetWidth);
    console.log('Has overflow:', productsContainer.scrollWidth > productsContainer.offsetWidth);
    
    let isScrolling = false;
    let scrollTimeout;
    
    // 计算滑动距离
    function getScrollDistance() {
      // 获取第一个产品卡片的宽度（包括间距）
      const firstProductCard = productsContainer.querySelector('.mt-product-showcase__product-card');
      if (firstProductCard) {
        const cardWidth = firstProductCard.offsetWidth;
        
        // 根据屏幕尺寸确定gap值
        const isMobile = window.innerWidth <= 768;
        const gap = isMobile ? 16 : 18; // 移动端16px，桌面端18px
        
        // 返回一个产品卡片的完整宽度（包括间距）
        const scrollDistance = cardWidth + gap;
        console.log('Card width:', cardWidth, 'Gap:', gap, 'Total scroll distance:', scrollDistance);
        return scrollDistance;
      }
      
      // 如果没有找到产品卡片，则使用默认的容器宽度
      const containerWidth = productsContainer.offsetWidth;
      const scrollWidth = productsContainer.scrollWidth;
      const maxScroll = scrollWidth - containerWidth;
      return Math.min(containerWidth * 0.8, maxScroll);
    }
    
    // 更新箭头状态
    function updateArrowStates() {
      if (leftArrow) {
        leftArrow.disabled = productsContainer.scrollLeft <= 0;
      }
      if (rightArrow) {
        rightArrow.disabled = productsContainer.scrollLeft >= productsContainer.scrollWidth - productsContainer.offsetWidth;
      }
    }
    
    // 更新滚动条
    function updateScrollbar() {
      if (!scrollbar || !scrollbarThumb) {
        console.log('Scrollbar elements not found:', { scrollbar, scrollbarThumb });
        return;
      }
      
      // 检查是否需要显示滚动条
      const hasOverflow = productsContainer.scrollWidth > productsContainer.offsetWidth;
      scrollbar.style.display = hasOverflow ? 'block' : 'none';
      
      // 强制显示滚动条进行测试（如果需要的话）
      // scrollbar.style.display = 'block';
      
      console.log('Scrollbar update:', {
        hasOverflow,
        scrollWidth: productsContainer.scrollWidth,
        offsetWidth: productsContainer.offsetWidth,
        scrollLeft: productsContainer.scrollLeft,
        scrollbarDisplay: scrollbar.style.display
      });
      
      if (hasOverflow) {
        const scrollProgress = productsContainer.scrollLeft / (productsContainer.scrollWidth - productsContainer.offsetWidth);
        const maxThumbWidth = scrollbarTrack.offsetWidth - scrollbarThumb.offsetWidth;
        const thumbLeft = scrollProgress * maxThumbWidth;
        
        scrollbarThumb.style.left = thumbLeft + 'px';
        
        console.log('Thumb position:', {
          scrollProgress,
          maxThumbWidth,
          thumbLeft,
          thumbWidth: scrollbarThumb.offsetWidth,
          trackWidth: scrollbarTrack.offsetWidth
        });
      }
    }
    
    // 滑动到下一个
    function scrollNext() {
      console.log('scrollNext called');
      if (isScrolling) {
        console.log('Already scrolling, ignoring');
        return;
      }
      
      isScrolling = true;
      const scrollDistance = getScrollDistance();
      const targetScroll = Math.min(
        productsContainer.scrollLeft + scrollDistance,
        productsContainer.scrollWidth - productsContainer.offsetWidth
      );
      
      console.log('Current scrollLeft:', productsContainer.scrollLeft);
      console.log('Scroll distance:', scrollDistance);
      console.log('Target scroll:', targetScroll);
      
      // 显示产品卡片信息
      const firstProductCard = productsContainer.querySelector('.mt-product-showcase__product-card');
      if (firstProductCard) {
        console.log('Product card width:', firstProductCard.offsetWidth);
        console.log('Product card style:', window.getComputedStyle(firstProductCard).margin);
      }
      
      productsContainer.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
      
      setTimeout(() => {
        isScrolling = false;
        updateArrowStates();
        updateScrollbar();
        console.log('Scroll animation completed');
      }, 500);
    }
    
    // 滑动到上一个
    function scrollPrev() {
      if (isScrolling) return;
      
      isScrolling = true;
      const scrollDistance = getScrollDistance();
      const targetScroll = Math.max(
        productsContainer.scrollLeft - scrollDistance,
        0
      );
      
      productsContainer.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
      
      setTimeout(() => {
        isScrolling = false;
        updateArrowStates();
        updateScrollbar();
      }, 500);
    }
    
    // 绑定箭头按钮事件
    if (leftArrow) {
      console.log('Left arrow found:', leftArrow);
      leftArrow.addEventListener('click', function(e) {
        console.log('Left arrow clicked');
        e.preventDefault();
        scrollPrev();
      });
    } else {
      console.log('Left arrow not found');
    }
    
    if (rightArrow) {
      console.log('Right arrow found:', rightArrow);
      rightArrow.addEventListener('click', function(e) {
        console.log('Right arrow clicked');
        e.preventDefault();
        scrollNext();
      });
    } else {
      console.log('Right arrow not found');
    }
    
    // 监听滚动事件
    productsContainer.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        updateArrowStates();
        updateScrollbar();
      }, 10);
    });
    
    // 滚动条点击事件
    if (scrollbarTrack) {
      scrollbarTrack.addEventListener('click', function(e) {
        const rect = scrollbarTrack.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const clickPercent = clickX / scrollbarTrack.offsetWidth;
        const maxScroll = productsContainer.scrollWidth - productsContainer.offsetWidth;
        const targetScroll = clickPercent * maxScroll;
        
        productsContainer.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      });
    }
    
    // 触摸滑动支持
    let startX = 0;
    let startScrollLeft = 0;
    let isDragging = false;
    
    productsContainer.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startScrollLeft = productsContainer.scrollLeft;
      isDragging = true;
    });
    
    productsContainer.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      
      const currentX = e.touches[0].clientX;
      const diff = startX - currentX;
      productsContainer.scrollLeft = startScrollLeft + diff;
    });
    
    productsContainer.addEventListener('touchend', function(e) {
      isDragging = false;
      
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      const threshold = 50;
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          // 向左滑动，下一个
          scrollNext();
        } else {
          // 向右滑动，上一个
          scrollPrev();
        }
      }
    });
    
    // 键盘导航
    container.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollPrev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollNext();
      }
    });
    
    // 初始化状态
    updateArrowStates();
    updateScrollbar();
    
    // 监听窗口大小变化
    window.addEventListener('resize', function() {
      setTimeout(() => {
        updateArrowStates();
        updateScrollbar();
      }, 100);
    });
  });
  
  // 全局测试函数
  window.testShowcaseArrows = function() {
    console.log('=== Testing Showcase Arrows ===');
    const containers = document.querySelectorAll('.mt-product-showcase__container');
    console.log('Found containers:', containers.length);
    
    containers.forEach((container, index) => {
      console.log(`\nContainer ${index}:`);
      const rightSection = container.querySelector('.mt-product-showcase__right');
      if (!rightSection) {
        console.log('Right section not found');
        return;
      }
      
      const leftArrow = rightSection.querySelector('.mt-product-showcase__arrow--left');
      const rightArrow = rightSection.querySelector('.mt-product-showcase__arrow--right');
      const productsContainer = rightSection.querySelector('.mt-product-showcase__products');
      
      console.log('Left arrow:', leftArrow);
      console.log('Right arrow:', rightArrow);
      console.log('Products container:', productsContainer);
      
      if (productsContainer) {
        console.log('Scroll width:', productsContainer.scrollWidth);
        console.log('Offset width:', productsContainer.offsetWidth);
        console.log('Scroll left:', productsContainer.scrollLeft);
        console.log('Has overflow:', productsContainer.scrollWidth > productsContainer.offsetWidth);
        
        // 显示产品卡片信息
        const productCards = productsContainer.querySelectorAll('.mt-product-showcase__product-card');
        console.log('Product cards count:', productCards.length);
        if (productCards.length > 0) {
          const firstCard = productCards[0];
          console.log('First card width:', firstCard.offsetWidth);
          console.log('First card style:', window.getComputedStyle(firstCard).margin);
        }
      }
    });
  };
  
  // 手动测试箭头点击
  window.testArrowClick = function() {
    const rightSection = document.querySelector('.mt-product-showcase__right');
    if (rightSection) {
      const rightArrow = rightSection.querySelector('.mt-product-showcase__arrow--right');
      if (rightArrow) {
        console.log('Manually clicking right arrow...');
        rightArrow.click();
      } else {
        console.log('Right arrow not found in right section');
      }
    } else {
      console.log('Right section not found');
    }
  };
  
  // 测试滑动距离计算
  window.testScrollDistance = function() {
    const containers = document.querySelectorAll('.mt-product-showcase__container');
    containers.forEach((container, index) => {
      const rightSection = container.querySelector('.mt-product-showcase__right');
      if (rightSection) {
        const productsContainer = rightSection.querySelector('.mt-product-showcase__products');
        const firstProductCard = productsContainer.querySelector('.mt-product-showcase__product-card');
        
        if (firstProductCard) {
          const cardWidth = firstProductCard.offsetWidth;
          const isMobile = window.innerWidth <= 768;
          const gap = isMobile ? 16 : 18;
          const scrollDistance = cardWidth + gap;
          
          console.log(`Container ${index}:`);
          console.log('Card width:', cardWidth);
          console.log('Is mobile:', isMobile);
          console.log('Gap:', gap);
          console.log('Scroll distance:', scrollDistance);
        }
      }
    });
  };
  
  // 测试滚动条状态
  window.testScrollbar = function() {
    const containers = document.querySelectorAll('.mt-product-showcase__container');
    containers.forEach((container, index) => {
      const rightSection = container.querySelector('.mt-product-showcase__right');
      if (rightSection) {
        const scrollbar = rightSection.querySelector('.mt-product-showcase__scrollbar');
        const scrollbarThumb = rightSection.querySelector('.mt-product-showcase__scrollbar-thumb');
        const scrollbarTrack = rightSection.querySelector('.mt-product-showcase__scrollbar-track');
        const productsContainer = rightSection.querySelector('.mt-product-showcase__products');
        
        console.log(`\nScrollbar test for container ${index}:`);
        console.log('Scrollbar found:', !!scrollbar);
        console.log('Scrollbar thumb found:', !!scrollbarThumb);
        console.log('Scrollbar track found:', !!scrollbarTrack);
        
        if (scrollbar && scrollbarThumb && scrollbarTrack && productsContainer) {
          console.log('Scrollbar display:', scrollbar.style.display);
          console.log('Thumb left position:', scrollbarThumb.style.left);
          console.log('Thumb width:', scrollbarThumb.offsetWidth);
          console.log('Track width:', scrollbarTrack.offsetWidth);
          console.log('Products scroll width:', productsContainer.scrollWidth);
          console.log('Products offset width:', productsContainer.offsetWidth);
          console.log('Products scroll left:', productsContainer.scrollLeft);
          
          // 强制显示滚动条进行测试
          scrollbar.style.display = 'block';
          console.log('Forced scrollbar to display');
        }
      }
    });
  };
  
  // 强制显示所有滚动条
  window.showAllScrollbars = function() {
    const scrollbars = document.querySelectorAll('.mt-product-showcase__scrollbar');
    scrollbars.forEach((scrollbar, index) => {
      scrollbar.style.display = 'block';
      console.log(`Forced scrollbar ${index} to display`);
    });
  };
});